import React from 'react';
import { Link } from 'react-router-dom';
import Logo from 'assets/img/Logo.svg';
import './Page404.css';

const Page404: React.FC = () => {
  return (
    <>
      <header className="header">
        <div className="header-logo">
          <Link to="/" target="_blank">
            <img src={Logo} alt="ELSA" />
          </Link>
        </div>
      </header>
      <div className="notfound-container">
        <div className="max-width-allpage notfound-page">
          <img
            width="430px"
            height="320px"
            src="https://vn.elsaspeak.com/wp-content/themes/elsa-tot/static/images/404-img.png"
            alt="NotFound"
          />
          <h1 className="error-notfound-text text-bigsize">Ooops...</h1>
          <p className="error-notfound-text">
            Trang bạn vừa truy cập không tồn tại hoặc đã bị xóa.
          </p>
          <Link to="/" className="return-btn">
            Quay lại
          </Link>
        </div>
      </div>
    </>
  );
};

export default Page404;
